import { connect } from 'react-redux';

export default (WrappedComp) => process.env.STORYBOOK_ON ? WrappedComp : connect(({ browser }) => ({
  browser,
  isMobile: browser.lessThan.md,
}))(WrappedComp);
